import React, { useEffect } from "react";
import { GlobalSearchProvider } from "./Components/GlobalSearch/context";
import { LanguageProvider } from "./contexts/LanguageContext";
import { CartProvider } from "./Components/Checkout/context";
import { useLocation } from "react-router-dom";

const AppWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [location.pathname]);

  return (
    <CartProvider>
      <GlobalSearchProvider>
        <LanguageProvider>
          {children}
        </LanguageProvider>
      </GlobalSearchProvider>
    </CartProvider>
  );
};

export default AppWrapper;
